
import Vue from "vue";
import VueRouter from "vue-router";

import checkForWebGL from "./middleware/checkForWebGL";
import hasLoaded from "./middleware/hasLoaded";

import PageAbout from "./views/pages/About.vue";
import PageDatepicker from "./views/pages/Datepicker.vue";
import PageExperience from "./views/pages/Experience.vue";
import PageHome from "./views/pages/Home.vue";
import PageNotFound from "./views/pages/NotFound.vue";
import PagePrivacy from "./views/pages/Privacy.vue";
import PageShare from "./views/pages/Share.vue";
import PageTerms from "./views/pages/Terms.vue";
import PageVideo from "./views/pages/Video.vue";

Vue.use(VueRouter);

const routerInstance = new VueRouter({
    mode: window.historyMode,
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "PageHome",
            component: PageHome,
            meta: { middleware: checkForWebGL },
        },
        {
            path: "/about",
            name: "PageAbout",
            component: PageAbout,
            meta: {
                middleware: [checkForWebGL, hasLoaded],
            },
        },
        {
            path: "/birthday",
            name: "PageDatepicker",
            component: PageDatepicker,
            meta: {
                middleware: [checkForWebGL, hasLoaded],
            },
        },
        {
            path: "/experience",
            name: "PageExperience",
            component: PageExperience,
            meta: {
                middleware: [checkForWebGL, hasLoaded],
            },
        },
        {
            path: "/404",
            name: "PageNotFound",
            component: PageNotFound,
            meta: {
                middleware: [checkForWebGL, hasLoaded],
            },
        },
        // {
        //     path: "/privacy-policy",
        //     name: "PagePrivacy",
        //     component: PagePrivacy,
        //     meta: { middleware: checkForWebGL },
        // },
        {
            path: "/share",
            name: "PageShare",
            component: PageShare,
            meta: {
                // middleware: [checkForWebGL, hasLoaded],
                middleware: checkForWebGL,
            },
        },
        // {
        //     path: "/terms-and-conditions",
        //     name: "PageTerms",
        //     component: PageTerms,
        //     meta: { middleware: checkForWebGL },
        // },
        {
            path: "/video",
            name: "PageVideo",
            component: PageVideo,
            meta: {
                middleware: [checkForWebGL, hasLoaded],
            },
        },
        {
            path: "*",
            redirect: "/404",
        },
    ],
});

/**
 * [nextFactory description]
 *
 * @param  {[type]} context    [description]
 * @param  {[type]} middleware [description]
 * @param  {[type]} index      [description]
 *
 * @return {[type]}            [description]
 */
function nextFactory(context: IRouterContext, middleware: [(arg0: any) => void], index: number)
{
    const subsequentMiddleware = middleware[index];
    if (!subsequentMiddleware) {
        return context.next;
    }

    return (...parameters: any[]) => {
        // Run the default Vue Router `next()` callback first.
        context.next(...parameters);

        // Than run the subsequent Middleware with a new
        // `nextMiddleware()` callback.
        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({
            ...context,
            next: nextMiddleware,
        });
    };
}

/**
 * [description]
 *
 * @param  {[type]} (to, from,         next [description]
 *
 * @return {[type]}      [description]
 */
routerInstance.beforeEach((to: any, from: any, next: () => void) => {
    if (to.meta.middleware) {
        const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];
        const context = { from, next, router, to };
        const nextMiddleware = nextFactory(context, middleware, 1);

        return middleware[0]({
            ...context,
            next: nextMiddleware,
        });
    }

    return next();
});

/**
 * Export
 */
export let router = routerInstance;
